import { ModalParts } from 'BreetComponents';
import { useFundRequestContext } from 'BreetHooks';

import CryptoFundingMethod from './forms/crypto/Crypto';
import FiatFundingMethod from './forms/fiat/Fiat';
import FundingMethod from './FundingMethod';
import Header from './Header';

const Child = () => {
	const { fundingMethod } = useFundRequestContext();

	const FundingComponent = fundingMethod === 'Crypto' ? CryptoFundingMethod : FiatFundingMethod;

	return (
		<ModalParts.Wrapper
			title='Fund Wallet'
			root='Fund Wallet'
			rightSheet
		>
			<div
				className='payment-request-form withdraw-request-form'
				data-testid='withdraw-form'
			>
				<Header />

				<FundingMethod />

				{!fundingMethod ? null : <FundingComponent />}
			</div>
		</ModalParts.Wrapper>
	);
};

export default Child;
